import { useRequest } from 'ahooks';
import { message } from 'antd';
import dayjs from 'dayjs';
import { head, last } from 'lodash-es';
import { useEffect } from 'react';
import { useTranslate } from '@tolgee/react';
import { useAtomValue, useSetAtom } from 'jotai';
import { atomWithRefresh } from 'jotai/utils';
import { ExportCount, getExportCount } from 'services/api/admin';
import nimInst from 'services/nim';
import download, { checkDownloadPath } from 'utils/download';

const downloadCountState = atomWithRefresh(() => {
  return getExportCount()
    .then((res) => {
      return res;
    })
    .catch(
      () =>
        ({
          successCount: 0,
          failCount: 0,
          total: 0,
          inProgressCount: 0,
          lastDownloadCreateTimeStamp: 0,
        } as ExportCount),
    );
});

export const useExportCount = () => useAtomValue(downloadCountState);

export const useRefreshExportCount = () => useSetAtom(downloadCountState);

export const useListenExportFileMsg = () => {
  const refreshExportCount = useRefreshExportCount();
  const { t } = useTranslate();
  useEffect(() => {
    return nimInst.on('sys:message:export_file', (data) => {
      const fileDownloadUrl = data?.content?.result;
      if (!fileDownloadUrl) {
        return;
      }
      const filename = decodeURIComponent(
        head(last(fileDownloadUrl.split('/'))?.split('?')) ??
          `download_${dayjs('YYYY-MM-DD HH:mm:ss')}.xlsx`,
      );
      download(fileDownloadUrl, filename)
        .then((status) => {
          if (status) {
            message.success(t('export_modal_downloaded') + ':' + filename);
          }
        })
        .catch(() => message.error(t('ViewShops.导出失败') + ':' + filename))
        .finally(() => {
          refreshExportCount();
        });
    });
  }, [refreshExportCount, t]);
};
export const floatButtonHideCacheKey = `${
  import.meta.env.VITE_NAME || ''
}/download-float-button-hide`;

export const useExportFile = () => {
  const { t } = useTranslate();
  const refreshExportCount = useRefreshExportCount();
  return useRequest(
    async (request: () => Promise<any>) => {
      const ready = await checkDownloadPath();
      if (!ready) {
        return Promise.reject(
          '!!! can not find download path, maybe user cancel download path permission request',
        );
      }
      try {
        await request();
        localStorage.removeItem(floatButtonHideCacheKey);
        refreshExportCount();
        message.info(t('export_modal_downloading'));
      } catch (error) {
        message.error(t('phrase.获取数据失败，请稍后再试'));
      }
      return Promise.resolve();
    },
    { manual: true },
  );
};
